// AlarmQueryBuilder: Utility to build query params for the alarms API
export interface AlarmQueryParams {
  limit: number;
  offset: number;
  // Placeholder for search param (not implemented yet)
  search?: string;
  state?: number;
  // Add more filter/sort/search params as needed
}

/**
 * Builds the query params object for the alarms API.
 * Note: 'silence' param is intentionally omitted and will never be sent to the API.
 * @param page - Current page number (1-based)
 * @param limit - Number of items per page
 * @param extra - Optional extra params (filters, sorts, etc)
 */
export function buildAlarmQueryParams(
  page: number,
  limit: number,
  state?: number,
  search?: string,
  silence?: boolean | null,
): AlarmQueryParams {
  // Destructure and discard 'silence' so it is never sent
  // 'search' is a placeholder and not included in the returned params yet
  return {
    limit,
    offset: (page - 1) * limit,
    state: state != null ? state : undefined,

    // search, // Uncomment when implementing search
    // silence // uncomment when implementing
  };
}
